import Flickity from "../../node_modules/flickity";

document.addEventListener("alpine:init", () => {
    Alpine.data("videoSlider", () => ({
        slider: null,
        sliderContainer: null,
        sliderEnd: false,
        activeIndex: 0,
        userInitiatedChange: false,

        init() {
            this.sliderContainer = this.$refs.slider;
            const slides = this.sliderContainer.querySelectorAll(
                ".Video__Slider-slide",
            );

            this.slider = new Flickity(this.sliderContainer, {
                cellAlign: "center",
                contain: true,
                wrapAround: false,
                prevNextButtons: false,
                pageDots: false,
                draggable: true,
                autoPlay: 5000,
                pauseAutoPlayOnHover: false,
                on: {
                    settle: () => {
                        this.updateTabIndexes(slides);

                        // If user moved the slider, restart autoplay interval from zero.
                        if (this.userInitiatedChange) {
                            this.slider.stopPlayer();
                            this.slider.playPlayer();
                            this.userInitiatedChange = false;
                        }
                    },
                    ready: () => {
                        window.dispatchEvent(new Event("resize"));
                        this.sliderResize();
                    },
                },
            });

            // Mark user-initiated interactions (drag, touch, click)
            this.slider.on("pointerDown", () => {
                this.userInitiatedChange = true;
            });

            this.slider.on("change", (index) => {
                this.updateTabIndexes(slides);
                this.updateSliderEnd();
                this.activeIndex = index;
            });

            pegasus.onResizeFinished(() => {
                this.sliderResize();
            }, false);

            this.updateTabIndexes(slides);
            this.updateSliderEnd();
        },

        sliderResize() {
            const flickitySliders = document.querySelectorAll(
                ".Video__Slider-slider .flickity-slider",
            );

            this.sliderFullWidth = 0;

            flickitySliders.forEach((slider) => {
                const slides = slider.querySelectorAll(".Video__Slider-slide");
                let height = 0;

                slides.forEach((slide) => {
                    slide.style.height = "";
                    this.sliderFullWidth += slide.offsetWidth;
                    if (slide.offsetHeight > height) {
                        height = slide.offsetHeight;
                    }
                });

                slides.forEach((slide) => {
                    slide.style.height = height + "px";
                });

                slider.style.height = "";
                slider.style.height = height + "px";
                console.log("resize");
            });
        },

        /**
         * updateTabIndexes
         *
         * Description: Updates the tabindexes of the slides this is required for accessibility.
         * Inactive slides shouldn't be accessible via the keyboard.
         *
         * @param {} slides
         */
        updateTabIndexes(slides) {
            slides.forEach((slide) => {
                const slideElements = slide.querySelectorAll("a, button");

                slideElements.forEach((element) => {
                    if (slide.classList.contains("is-selected")) {
                        element.removeAttribute("tabindex");
                    } else {
                        element.setAttribute("tabindex", "-1");
                    }
                });
            });
        },

        /**
         * updateSliderEnd
         *
         * Description: Updates sliderEnd property based on whether the slider is at the end or not.
         */
        updateSliderEnd() {
            const selectedIndex = this.slider.selectedIndex;
            const slideCount = this.slider.slides.length;
            this.sliderEnd = selectedIndex === slideCount - 1;
        },
    }));
});
